module.exports = {
          srcSet: __webpack_public_path__ + "d740f5073c1c0215900660dbc548be35-1100.png"+" 1100w",
          images:[ {path: __webpack_public_path__ + "d740f5073c1c0215900660dbc548be35-1100.png",width: 1100,height: 866}],
          src: __webpack_public_path__ + "d740f5073c1c0215900660dbc548be35-1100.png",
          toString:function(){return __webpack_public_path__ + "d740f5073c1c0215900660dbc548be35-1100.png"},
          
          width: 1100,
          height: 866
        }